import { render, staticRenderFns } from "./BuyerTypeToggle.vue?vue&type=template&id=2250cd88&scoped=true"
import script from "./BuyerTypeToggle.vue?vue&type=script&lang=js"
export * from "./BuyerTypeToggle.vue?vue&type=script&lang=js"
import style0 from "./BuyerTypeToggle.vue?vue&type=style&index=0&id=2250cd88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250cd88",
  null
  
)

export default component.exports